import { Button, Container } from 'react-bootstrap';
import Banner from '../../Component/Banner';
import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { get, ref, set } from 'firebase/database';

import { db } from '../../ReactNative/firebase';

const PapaLadsTrivia = () => {
    const [question, setQuestion] = useState(0)
    const [startTime] = useState(() => Date.now());
    const navigate = useNavigate()
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [elapsedTime, setElapsedTime] = useState(0);
    const [userAnswers, setUserAnswers] = useState(
        [
            {
                id: 0,
                answer: ''
            },
            {
                id: 1,
                answer: ''
            },
            {
                id: 2,
                answer: ''
            },
            {
                id: 3,
                answer: ''
            },
            {
                id: 4,
                answer: ''
            },
            {
                id: 5,
                answer: ''
            },
            {
                id: 6,
                answer: ''
            },
            {
                id: 7,
                answer: ''
            },
            {
                id: 8,
                answer: ''
            },
            {
                id: 9,
                answer: ''
            }
        ]
    )

    const answerArray = useMemo(() => [
        'Sili, Naguilian',
        '1977',
        'ECE',
        '35 years',
        'Transmitter Engineer',
        'Negros Oriental',
        '44 years',
        'All of Me by John Legend',
        '6',
        '5',
    ], [])
    
    var questionArray = [
        "Where was Ladz born?",
        'What year did he graduate college?',
        "Ladz is an alumni of Saint Louis University. What was his major?",
        "Ladz worked in Saudi Arabia for decades. How many years before he retired?",
        "What kind of work did he do?",
        "Where did Ladz and Norly meet?",
        "How long have they been married?",
        'This is Ladz’s favorite song.',
        "Including Ladz, how many siblings are there?",
        "How many grandchildren do Ladz and Norly have?"
    ]

    var choicesArray = [
        [
            'Sili, Naguilian',
            'San Fernando, La Union',
            'Bacolod, Negros Occidental',
            'Baguio City',
        ],
        [
            '1975',
            '1976',
            '1977',
            '1978',
        ],
        [
            'CE',
            'EE',
            'ECE',
            'ME',
        ],
        [
            '25 years',
            '30 years',
            '35 years',
            '40 years',
        ],
        [
            'Transmitter Engineer',
            'Communications Officer',
            'Broadcast Operator',
            'Civil Engineer',
        ],
        [
            'Negros Oriental',
            'Negros Occidental',
            'Dumaguete',
            'Iloilo',
        ],
        [
            '41 years',
            '42 years',
            '43 years',
            '44 years',
        ],
        [
            'All of Me by John Legend',
            'Endless Love by Lionel Richie and Diana Ross',
            'Put Your Head on my Shoulder by Paul Anka',
            'Purple Rain by Prince',
        ],
        [
            '3',
            '4',
            '5',
            '6',
        ],
        [
            '2',
            '3',
            '4',
            '5',
        ]
    ]

    const finishQuiz = () => {
        const endTime = Date.now();
        const timeTaken = Math.floor((endTime - startTime) / 1000);
    
        let userScore = 0;
    
        for (let i = 0; i < answerArray.length; i++) {
            if (answerArray[i] === userAnswers[i].answer) {
                userScore++;
            }
        }
    
        sessionStorage.setItem('PapaLadsTriviaScore', userScore);
        sessionStorage.setItem('PapaLadsTriviaTime', timeTaken);
    
        get(ref(db, 'PapaLadsTriviaScoreboard/')).then((snap) => {
            const theNewValue = [];
        
            const data = Object.values(snap.val() || {});
        
            data.forEach(item => {
                theNewValue.push(item);
            });
        
            theNewValue.push({
                email: sessionStorage.getItem('PapaLadsTriviaEmail'),
                name: sessionStorage.getItem('PapaLadsTriviaName'),
                score: userScore,
                time: timeTaken
            });
        
            set(ref(db,'PapaLadsTriviaScoreboard/'), theNewValue);
        });
    
        navigate('/QuizTrivias/June2026/papaladsend');
    }

    useEffect(() => {
        if (question === 0) {
            window.scrollTo(0, 0);
        }
    
        const score = sessionStorage.getItem('PapaLadsTriviaScore');
        const started = sessionStorage.getItem('PapaLadsTriviaStarted');
        const email = sessionStorage.getItem('PapaLadsTriviaEmail');
    
        if (score) {
            alert("Looks like you've already taken the quiz. Thanks for participating!");
            navigate('/QuizTrivias/June2026/papaladsend');
            return;
        }
    
        if (!started) {
            alert("Please start the quiz properly.");
            navigate('/QuizTrivias/June2026/papalads');
            return;
        }
    
        if (!email) {
            alert("Seems like you haven't added your info. Please do so first.");
            navigate('/QuizTrivias/June2026/papalads');
            return;
        }
    }, [navigate, question]);
    
    useEffect(() => {
        const interval = setInterval(() => {
            setElapsedTime(
                Math.floor((Date.now() - startTime) / 1000)
            );
        }, 1000);
    
        return () => clearInterval(interval);
    }, [startTime]);

    const isAnswered = !!userAnswers[question]?.answer;
    function showChoices() {
        const options = choicesArray[question];
    
        function handleSelect(index) {
            const updated = userAnswers.map((a, i) => {
                if (i === question) {
                    return {
                        ...a,
                        answer: options[index]
                    };
                }
                return a;
            });
    
            setUserAnswers(updated);
            setSelectedIndex(index);
        }
    
        return (
            <div className="buttonToEdit">
                {options.map((opt, i) => (
                    <div key={i}>
                        <Button
                            onClick={() => handleSelect(i)}
                            className={`ybtnSizeUp ybtn-papa-option ${
                                selectedIndex === i ? "ybtn-papa-selected" : ""
                            }`}
                        >
                            {opt}
                        </Button>
                        <br /><br />
                    </div>
                ))}
            </div>
        );
    }
    const progressText = `Question ${question + 1} / ${questionArray.length}`;
    const minutes = Math.floor(elapsedTime / 60);
    const seconds = elapsedTime % 60;

    const timerText = `${minutes}:${seconds
        .toString()
        .padStart(2, '0')}`;
    return (
        <>
            <Container className="keiki-party papalads-70th">

                <Banner caption=""/>
            <div className='text-center'>
                <div className='Apps'>
                    <br />
                    <h3 className="fontBackground Trivia-Timer">
                    ⏱ {timerText}
                </h3>
                <h4 className="fontBackground">{progressText}</h4>
                    <h2 className='fontBackground'>{questionArray[question]}</h2>
                    {showChoices()}
                    <br />
                    <Button
                        disabled={!isAnswered}
                        onClick={() => {
                            if (!isAnswered) {
                                alert("Please select an answer first!");
                                return;
                            }

                            if (question < questionArray.length - 1) {
                                setQuestion(q => q + 1);
                                setSelectedIndex(null);
                            } else {
                                finishQuiz();
                            }
                        }}
                        className={`ybtnSizeUp ${isAnswered ? "ybtn-next" : "ybtn-next-disabled"}`}
                    >
                        {question === questionArray.length - 1 ? "Finish" : "Next"}
                    </Button>
                </div>
            </div>
            </Container>
        </>
    )
}

export default PapaLadsTrivia;